import { render } from "./JFCResult.vue?vue&type=template&id=2ec13df3&scoped=true"
import script from "./JFCResult.vue?vue&type=script&lang=js"
export * from "./JFCResult.vue?vue&type=script&lang=js"

import "./JFCResult.vue?vue&type=style&index=0&id=2ec13df3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec13df3"],['__file',"src/scripts/view/jobFitChecker/components/JFCResult.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ec13df3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ec13df3', __exports__)) {
    api.reload('2ec13df3', __exports__)
  }
  
  module.hot.accept("./JFCResult.vue?vue&type=template&id=2ec13df3&scoped=true", () => {
    api.rerender('2ec13df3', render)
  })

}


export default __exports__